import { axiosGet, axiosPost } from '@/app/helpers/AxiosHelper';

export default {
    state: {
        accAppId: null,
        accApp: null,
        countries: [],
        provinces: [],
        cantons: [],
        versionOptions: {
            accreditationAreas: [],
            typesDocuments: [],
        },
    
    },

    getters: {
        getProvinces: state => country_id => {
            return state.provinces.filter(province => province.parent == country_id)
        },
        getCantons: state => province_id => {
            return province_id ? state.cantons.filter(canton => canton.parent == province_id) : state.cantons
        }
    },

    mutations: {
        POLITICAL_DIVISION(state, data) {
            state.countries = data.countries;
            state.provinces = data.provinces;
            state.cantons = data.cantons;
        },

        SET_VERSIONS(state, data) {
            state.versionOptions = data;
        },
    },

    actions: {
        getPoliticalDivision({ commit, state }) {
            const url = '/common/politicalDivision';
            if (state.countries.length == 0) {
                axiosGet(url).then(res => {
                    if (res.status == 200) {
                        commit('POLITICAL_DIVISION', res.data);
                    }
                });
            }
        },

        registerFileLog({ commit, state }, data) {
            const url = `/audit-file-log/store`;
            axiosPost(url, data).then(res => {
              if (res.status == 200) {
                commit('SET_APP_OPTIONS', res.data);
              }
            });
          },

        getVersionOptions({ commit, state }) {
            const url = '/versions-file/versionOption';
            axiosGet(url).then(res => {
                if (res.status == 200) {
                commit('SET_VERSIONS', res.data);
                }
            });
        },
    }
}